import { CloudUpload, FileCheck } from 'lucide-react';
import { useState } from 'react';

import {
  FileInput,
  UploadedTitle,
  UploadHelperText,
  UploadTitle,
  VisuallyHiddenInput
} from './fileUpload.style';

type FileUploadProps = {
  onFileChange: (file: File) => void;
  uploadTitle?: string;
  uploadHelper?: string;
  accept?: string;
};

const FileUploadForm = ({
  uploadTitle,
  uploadHelper,
  onFileChange,
  accept
}: FileUploadProps) => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    onFileChange(uploadedFile);
  };

  return (
    <FileInput>
      <VisuallyHiddenInput
        accept={accept ?? '*/*'}
        onChange={handleFileChange}
        type="file"
      />
      {file && (
        <>
          <FileCheck size={40} />
          <UploadedTitle>{file.name}</UploadedTitle>
        </>
      )}
      {!file && (
        <>
          <CloudUpload size={40} />
          <UploadTitle>{uploadTitle ?? 'Upload a file'}</UploadTitle>
          <UploadHelperText>{uploadHelper}</UploadHelperText>
        </>
      )}
    </FileInput>
  );
};

export default FileUploadForm;
